var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[(_vm.isLoggedIn && ! _vm.isRegistered)?_c('NotRegistered'):(_vm.isLoggedIn && _vm.isRegistered)?_c('LoggedIn'):_c('LoggedOut')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }